import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  noFill?: boolean
  border?: boolean
}

const AiInsideArea = ({ children, border = false, noFill = false }: Props) => {
  return (
    <div className={clsx(`inline-grid w-full rounded-lg p-0.5`, border && 'border-ai')}>
      <div className={clsx('z-10', !noFill && 'bg-fill-ai-secondary rounded-lg p-1')}>
        {children}
      </div>
    </div>
  )
}

export default AiInsideArea
